import { css } from "styled-components";

export const disabledStyle = ({ disabled }: { disabled?: boolean }) => {
  if (disabled) {
    return css`
      background-color: ${({ theme }) => theme?.colors?.neutral.neutral30};
      border: ${({ theme }) => theme?.colors?.gray.gray10};
      cursor: not-allowed;
      color: ${({ theme }) => theme?.colors?.typography.disabled2};

      &::placeholder {
        color: ${({ theme }) => theme?.colors?.typography.disabled2};
      }
    `;
  }
};
